// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3fyMW","head":"Table_head__1vDd_","col":"Table_col__1G1gm"};